<template>
  <div>
    <list-page-header />
    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :tableActionsComponent="TableActions"
      :sortable="sortable"
      :sort-data="sortData"
      mainField="full_name"
      ref="graduationCategoriesTable"
    >
    </yv-index>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import { Message } from "@/helpers/utils";
import Vue from "vue";

export default {
  name: "ListPage",
  components: { YvIndex, ListPageHeader: Header },
  data() {
    return {
      item: null,
      TableActions,
      path: service_paths.graduation_categories,
      sortable: ["name", "status"],
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      formSearch: [
        {
          label: "graduation_category.filter_by_name",
          name: "name__~",
          value: "",
          type: "input",
          width: 25
        },
        {
          label: "common.status",
          name: "status",
          value: "",
          type: "select",
          options: [
            {
              id: "",
              name: "common.all"
            },
            {
              id: "Active",
              name: "common.active"
            },
            {
              id: "Inactive",
              name: "common.inactive"
            }
          ],
          width: 20
        },
        {
          label: "graduation_category.filter_by_program",
          name: "program_ids",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "id",
          displayField: "name",
          width: 20
        }
      ],
      columns: {
        name: "graduation_category.col_name",
        status: "common.status"
      }
    };
  },
  created() {
    this.getProgram();
  },
  methods: {
    async getProgram() {
      try {
        const res = await this.$axios.get(service_paths.programs);

        if (!res.data.data || !res.status === 200) {
          Vue.$log.error("[ERROR]: ", res);
          return;
        }
        const resData = res.data.data;
        this.formSearch[2].options = resData;
      } catch (error) {
        Vue.$log.error("[GET_ROLES_ERROR]: ", error);
      }
    },
    reFetchTableData() {
      return this.$refs.graduationCategoriesTable.getTableData();
    },
    // delete
    confirmDelete(item) {
      Swal.fire({
        title: this.$t("common.confirm"),
        text: this.$t("graduation_category.text_confirm_delete"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-danger btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("common.delete"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(item);
        }
      });
    },
    async delete(data) {
      const id = data.id || data._id;
      await this.$axios
        .delete(this.path + "/" + id)
        .then(async () => {
          await this.reFetchTableData();
          Message.success(this.$t("common.delete_success"));
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete,
      reFetchTableData: this.reFetchTableData
    };
  }
};
</script>

<style lang="scss">
.md-table-cell-container .md-button {
  margin: 0;
  min-width: 40px;
  height: 42px;
  justify-content: center;
  align-items: center;
  width: 20%;
}
</style>
